import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DynamicReport  {
    _originalTypeClassName = "zERP.BO.DynamicReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DynamicReport.translate = translateService;
}
this.History = [];
this.Images = [];
this.Variables = [];
this.Id = null;
this.Name = null;
this.SystemEntity = null;
this.IsDefault = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
SystemEntity:any;
IsDefault:any;
History:any;
ActiveTemplate:any;
Images:any;
Variables:any;
static setHistory = ($this, items) => {
                if (items == null) items = [];
                if ($this.History == null) $this.History = [];

                const copyItems = Common.cloneObject(items);

                while ($this.History.length > 0) {
                    Domain.DynamicReport.removeHistory($this, $this.History[0]);
                }

                Domain.DynamicReport.addManyHistory($this, copyItems);
            }
static addManyHistory = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.DynamicReport.addHistory($this, items[i]);
                }
            }
static addHistory = ($this, item) => {
                if ($this.History == null) $this.History = [];
                if (item == null || $this.History.indexOf(item) > -1) return;
                $this.History.push(item);
}
static addRangeHistory = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.DynamicReport.addHistory($this, item));
            }
static removeHistory = ($this, item) => {
                if ($this == null || $this.History == null || $this.History.indexOf(item) === -1) return;
                var _index = $this.History.indexOf(item);
                $this.History.splice(_index, 1);
}
static clearHistory = ($this) => { $this.History = null; }
static setActiveTemplate = ($this, value) => {
var oldValue = $this.ActiveTemplate;
$this.ActiveTemplate = value;
if (value != null) {
}
}
static setImages = ($this, items) => {
                if (items == null) items = [];
                if ($this.Images == null) $this.Images = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Images.length > 0) {
                    Domain.DynamicReport.removeImages($this, $this.Images[0]);
                }

                Domain.DynamicReport.addManyImages($this, copyItems);
            }
static addManyImages = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.DynamicReport.addImages($this, items[i]);
                }
            }
static addImages = ($this, item) => {
                if ($this.Images == null) $this.Images = [];
                if (item == null || $this.Images.indexOf(item) > -1) return;
                $this.Images.push(item);
}
static addRangeImages = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.DynamicReport.addImages($this, item));
            }
static removeImages = ($this, item) => {
                if ($this == null || $this.Images == null || $this.Images.indexOf(item) === -1) return;
                var _index = $this.Images.indexOf(item);
                $this.Images.splice(_index, 1);
}
static clearImages = ($this) => { $this.Images = null; }
static setVariables = ($this, items) => {
                if (items == null) items = [];
                if ($this.Variables == null) $this.Variables = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Variables.length > 0) {
                    Domain.DynamicReport.removeVariables($this, $this.Variables[0]);
                }

                Domain.DynamicReport.addManyVariables($this, copyItems);
            }
static addManyVariables = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.DynamicReport.addVariables($this, items[i]);
                }
            }
static addVariables = ($this, item) => {
                if ($this.Variables == null) $this.Variables = [];
                if (item == null || $this.Variables.indexOf(item) > -1) return;
                $this.Variables.push(item);
}
static addRangeVariables = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.DynamicReport.addVariables($this, item));
            }
static removeVariables = ($this, item) => {
                if ($this == null || $this.Variables == null || $this.Variables.indexOf(item) === -1) return;
                var _index = $this.Variables.indexOf(item);
                $this.Variables.splice(_index, 1);
}
static clearVariables = ($this) => { $this.Variables = null; }

static GetSystemicTemplateFileName(excelConverterEntity: any): any{switch (excelConverterEntity) {case Domain.ExcelConverterEntity.AssetDepreciations:
{
return "ET_AssetDepreciations.xlsx";}
case Domain.ExcelConverterEntity.BankAccountList:
{
return "ET_BankAccountList.xlsx";}
case Domain.ExcelConverterEntity.BankAccountTransactions:
{
return "ET_BankAccountTransactions.xlsx";}
case Domain.ExcelConverterEntity.Budget:
{
return "ET_BudgetApproval.xlsx";}
case Domain.ExcelConverterEntity.BudgetAdjustment:
{
return "ET_BudgetAdjustment.xlsx";}
case Domain.ExcelConverterEntity.CheckNotary:
{
return "ET_CheckNotary.xlsx";}
case Domain.ExcelConverterEntity.PaymentOrder:
{
return "ET_PaymentOrder_New.xlsx";}
case Domain.ExcelConverterEntity.Payroll:
{
return "ET_AnalyticalPayslip.xlsx";}
case Domain.ExcelConverterEntity.PayrollSummary:
{
return "ET_PayrollSummary.xlsx";}
case Domain.ExcelConverterEntity.PaySlip:
{
return "ET_PaySlip.xlsx";}
case Domain.ExcelConverterEntity.SpendingRequest:
{
return "ET_SpendingRequest.xlsx";}
case Domain.ExcelConverterEntity.TransactionEntity:
{
return "ET_Withheld_Tax.xlsx";}
case Domain.ExcelConverterEntity.LeaveRequest:
{
return "ET_leave_approval_template.xlsx";}
case Domain.ExcelConverterEntity.CVEmployee:
{
return "ET_CVEmlpoyee.xlsx";}
case Domain.ExcelConverterEntity.EmployeeOvertime:
{
return "ET_EmployeeOvertime.xlsx";}
case Domain.ExcelConverterEntity.PeriodOvertime:
{
return "ET_PeriodOvertime.xlsx";}
case Domain.ExcelConverterEntity.PaymentOrderPayment:
{
return "ET_PaymentOrderPayment.xlsx";}
case Domain.ExcelConverterEntity.PayrollAdvance:
{
return "ET_PayrollAdvance.xlsx";}
case Domain.ExcelConverterEntity.PayrollReport:
{
return "ET_PayrollReport.xlsx";}
case Domain.ExcelConverterEntity.AdhocAdvancePayment:
{
return "ET_AdhocAdvPayment.xlsx";}
case Domain.ExcelConverterEntity.EmployeeSalaryLoanInstalment:
{
return "ET_EmployeesSalaryLoanInstalments.xlsx";}
case Domain.ExcelConverterEntity.DetailedPayrollReport:
{
return "ET_Detail_Payroll_Report.xlsx";}
case Domain.ExcelConverterEntity.APD:
{
return "ET_APD_Report.xlsx";}
default:
{
return "";}
}
return "";
}
static GetTemplateFunctions($this: any): any{switch ($this?.SystemEntity) {case Domain.ExcelConverterEntity.PayrollSummary:
{
return Domain.PayrollSummaryExporter.GetFunctions();break;}
case Domain.ExcelConverterEntity.EmployeeOvertime:
{
return Domain.OvertimeExporter.GetFunctions();break;}
case Domain.ExcelConverterEntity.PeriodOvertime:
{
return Domain.OvertimeExporter.GetFunctions();break;}
}
let functions = [];
return functions;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}